import * as angular from "angular";

angular
  .module('bringoz.admin.branches')
  .constant('Branches_PN', {
    database: 'branches',
    isBranchEntity: false
  });
